import {format} from 'date-fns';
const modalDividendo = {
	props: ["eventDay", "dayClicked"],

	data() {
		return {
			id: null,
			baseURL: window.location.origin,
			event: null,
		};
	},

	methods: {
		fMoney(val){
			return Number(val).toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			})
		},
	},
	computed: {
		// Somado a partir das linhas exibidas para o total nunca divergir da tabela
		totalDay() {
			const total = (this.eventDay || []).reduce(
				(soma, item) => soma + Number(item.net_value || 0),
				0
			)
			return this.fMoney(total)
		},
	},
	template: html`
		<div>
			<div class="modal-dividendo" data-position="center">
				<section class="modal--content" data-id="1">
					<div class="modal-header">
						<img
							src="{% static 'front_assets/assets/src/img/bg-modal.svg' %}"
							alt=""
							class="bg-header-modal"
						/>
						<h3>{{dayClicked}}</h3>
						<button
							class="close-modal"
							type="button"
							data-id="1"
							data-xclose="modal-dividendo"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="px-24 py-32">
	

						<div class="relative overflow-x-auto">
							<table
								class="w-full text-left "
							>
								<thead class="text-base font-bold px-8 " style="background: #292c2e; color:#b9b9b9;">
									<tr>
										<th scope="col" class="px-8 py-10">Ativo</th>
										<th scope="col" class="px-8 py-10">Evento</th>
										<th scope="col" class="px-8 py-10">Valor</th>
						
									</tr>
								</thead>
								<tbody>
									<tr class="" v-for="item in eventDay" :key="item.id" style="border-bottom: 1px solid rgba(185,185,185, .2);">
										<th
											scope="row"
											class="px-8 py-4  "
										>
											{{item.ticker_symbol}}
										</th>
										<td class="px-8 py-4">{{item.corporate_action_type_description}}</td>
										<td class="px-8 py-4">{{fMoney(item.net_value)}}</td>
					
		
									</tr>
									
								</tbody>
							</table>
							
						</div>
						<p class="text-white text-base mt-32">Total do dia: {{ totalDay }}</p>
					</div>
		
				</section>
			</div>
		</div>
	`,
};

export default modalDividendo;
